import Report from "./ecg-report-component";
import Localized from "./localized";
import ErrorBoundary from "./error-boundary";

export { Localized, ErrorBoundary };
export default Report;
